import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonExternal } from '../ui/Button';
import { PhotoFrame } from '../ui/PhotoFrame';
import { ScriptEyebrow } from '../ui/ScriptEyebrow';
import { Reveal, stagger } from '../motion/Reveal';
import { FloatingPhoto } from '../motion/FloatingPhoto';
import { DoodleArrow } from '../brand/Doodles';
import { externalLinks } from '../../data/site';
import { firstVisitPhoto } from '../../data/photos';
const steps = [{
  title: 'Check the latest event details',
  copy: 'BCM normally meets Thursdays at 7:30 PM. Check the Events page or Instagram for that week’s confirmed location.'
}, {
  title: 'Head to the Student Union',
  copy: 'Most weeks, BCM meets on the third floor in Cape Florida Ballroom, Room 316.'
}, {
  title: 'Come as you are',
  copy: 'You can attend on your own or bring a friend. You do not need to be Baptist or already have everything figured out.'
}, {
  title: 'Let someone know you’re coming',
  copy: 'Complete the Get Connected form if you would like a BCM leader to follow up, answer a question, or help you find the room.'
}];
export function FirstThursday() {
  return <Section id="first-thursday" className="relative overflow-hidden bg-[#fffdf6] py-16 sm:py-20" labelledBy="first-thursday-heading" data-id="element-140" data-mp="9ighfofazsze">
      <Container data-id="element-141" data-mp="eex4sgeoi3bf">
        <div className="grid items-start gap-10 lg:grid-cols-[1fr_0.62fr] lg:gap-14" data-id="element-142" data-mp="126m2yde6lm0a">
          <div data-id="element-143" data-mp="124j5x9em2sm2">
            <Reveal data-id="element-144" data-mp="175ouqw55hvqb">
              <ScriptEyebrow accent="var(--bcm-light-blue)" data-id="element-145" data-mp="1768cocuswk4c">Your first Thursday</ScriptEyebrow>
              <h2 id="first-thursday-heading" className="mt-3 max-w-2xl font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-[2.6rem]" data-id="element-146" data-mp="s8xwwrb4ks2t">
                Your first Thursday doesn’t have to feel awkward
              </h2>
              <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-147" data-mp="3hxi2csg1f6q6">
                Here is what to know before you come.
              </p>
            </Reveal>

            <ol className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-148" data-mp="1oh40ebaxyy0d">
              {steps.map((step, index) => <Reveal key={step.title} as="li" delay={stagger(index)} className="flex h-full gap-4 rounded-[20px] border-2 border-brand-navy bg-brand-tan p-6 transition-transform duration-200 hover:-translate-y-1" data-id="element-149" data-mp="1jiak6b49sswi" data-mpi={index}>
                  <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-brand-navy bg-white font-display text-lg font-bold text-brand-navy" data-id="element-150" data-mp="10pgey8wg8f5h">
                    {index + 1}
                  </span>
                  <div data-id="element-151" data-mp="2q4wkzff2tkr5">
                    <h3 className="font-display text-xl font-bold leading-snug text-brand-navy" data-id="element-152" data-mp="2q320213t1sn2">
                      {step.title}
                    </h3>
                    <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-153" data-mp="2sp2oxn3oxb7p">
                      {step.copy}
                    </p>
                  </div>
                </Reveal>)}
            </ol>
          </div>

          {/* A single calm photo card, drifting on its own timing. */}
          <Reveal x={16} delay={0.15} className="relative hidden lg:block" data-id="element-154" data-mp="37e8k8zzeqhab">
            <FloatingPhoto range={6} duration={8} delay={0.4} data-id="element-155" data-mp="29pyimm3j9vjq">
              <PhotoFrame photo={firstVisitPhoto} ratio="aspect-[3/4]" rotate="rotate-2" className="transition-transform duration-300 hover:rotate-0" data-id="element-156" data-mp="29ri02g0xecn3" />
            </FloatingPhoto>
          </Reveal>
        </div>

        <Reveal delay={0.1} data-id="element-157" data-mp="2onz930ln7f6h">
          <div className="relative mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center" data-id="element-158" data-mp="2ol4s5j1u8cht">
            <ButtonExternal href={externalLinks.studentUnion} data-id="element-159" data-mp="3v5mcz71h0evt">Get Directions</ButtonExternal>
            <ButtonExternal href={externalLinks.getConnectedForm} variant="secondary" data-id="element-160" data-mp="3z33bv7deuz3">
              Get Connected
            </ButtonExternal>
            <a href={externalLinks.instagram} target="_blank" rel="noopener noreferrer" className="font-meta text-sm font-semibold text-brand-navy underline underline-offset-4 hover:no-underline sm:ml-2" data-id="element-161" data-mp="3tmw6ibap7fji">
              Ask on Instagram
            </a>
            <DoodleArrow className="pointer-events-none absolute -top-10 right-4 hidden h-14 w-14 lg:block" color="var(--bcm-pink)" data-id="element-162" data-mp="kfv3zak4648h" />
          </div>
        </Reveal>
      </Container>
    </Section>;
}